<template>
    <div
        class="whats-new"
        :class="[
            { show: show },
            isEnhancedLayout ? 'enhanced-layout' : 'classic-layout'
        ]"
    >
        <div class="title" @click="close()">
            <h4 class="m-0">What's New</h4>
            <i class="fas fa-times cursor-pointer"></i>
        </div>
        <div class="content-holder">
            <div>
                <div
                    class="content"
                    v-for="(release, index) in contents"
                    :key="index"
                >
                    <b-carousel
                        fade
                        indicators
                        :interval="0"
                        img-height="100"
                        class="mb-3"
                        v-model="carouselIndex[release.id]"
                        v-if="showSlider(release.whats_new.images)"
                    >
                        <a
                            href="javascript:void(0)"
                            v-on:click="
                                enlargeImage(release.id, release.whats_new)
                            "
                        >
                            <b-carousel-slide
                                v-for="(image, imgIndex) in release.whats_new
                                    .images"
                                :key="imgIndex"
                                :img-src="image.url"
                            ></b-carousel-slide>
                        </a>
                    </b-carousel>

                    <h4>{{ release.whats_new.title }}</h4>
                    <div>{{ _carbonDateDisplay(release.create_at) }}</div>
                    <div class="py-2">
                        <span
                            v-for="(label, labelId) in release.whats_new.labels"
                            class="badge badge-pill badge-primary mr-1"
                            :key="labelId"
                            >{{ label.name }}</span
                        >
                    </div>
                    <div v-html="release.whats_new.content"></div>
                </div>
                <div
                    v-if="contents.length === 0 && !isLoading"
                    class="no-release"
                >
                    <i class="fas fa-info-circle"></i>
                    <div>No new updates at the moment.</div>
                    <div class="refresh" @click="getContents(1)">Refresh</div>
                </div>

                <div class="module p-4" v-if="isLoading">
                    <b-row class="skeleton">
                        <b-col class="image">
                            <div></div>
                        </b-col>
                    </b-row>
                    <b-row class="skeleton">
                        <b-col class="content">
                            <div class="smaller"></div>
                            <div class="smaller"></div>
                            <div></div>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div
                v-if="!isLoading && currentPage < lastPage"
                class="load-more"
                @click="loadMore()"
            >
                Load More
            </div>
        </div>
        <image-viewer ref="imageViewer" />
    </div>
</template>
<script>
import Account from "@/services/account";
import Staff from "@/services/staff";
import { forEach } from "lodash";
import ImageViewer from "@/components/commons/image-viewer.vue";

export default {
    components: {
        ImageViewer
    },
    data() {
        return {
            contents: [],
            isLoading: false,
            currentPage: 1,
            lastPage: 1,
            carouselIndex: {},
            isFirstLoad: true
        };
    },
    computed: {
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        },
        show() {
            return this.$store.state.isWhatsNewOpen;
        }
    },
    watch: {
        show(newVal) {
            if (newVal === true) {
                this.open();
            }
        }
    },
    methods: {
        open() {
            this.contents = [];
            this.currentPage = 1;
            this.lastPage = 1;
            this.getContents();
        },
        enlargeImage(id, whatsNew) {
            const index = this.carouselIndex[id] ? this.carouselIndex[id] : 0;
            const image = whatsNew.images[index];
            this.$refs.imageViewer.open(image.url);
        },
        getContents(page) {
            let self = this;
            self.isLoading = true;
            Account.getReleaseNotes({ perPage: 10, page: page ? page : 1 })
                .then(response => {
                    if (response.message.code === 200 && response.resources) {
                        if (response.meta && response.meta.total > 0) {
                            this.currentPage = response.meta.currentPage;
                            this.lastPage = response.meta.lastPage;

                            forEach(response.resources, function (release) {
                                self.contents.push(release);
                                self.carouselIndex[release.id] = 0;
                            });

                            if (this.isFirstLoad) {
                                this.updateHasRead(response.resources[0].id);
                                this.isFirstLoad = false;
                            }
                        }
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        loadMore() {
            this.getContents(this.currentPage + 1);
        },
        showSlider(images) {
            return _.isArray(images) && images.length > 0;
        },
        close() {
            this.$store.commit("toggleWhatsNew", false);
        },
        updateHasRead(releaseNoteId) {
            let currentActor = this.$root.currentActor;

            Staff.updateReleaseNote(currentActor.id, releaseNoteId)
                .then(response => {
                    if (_.isArray(response.data)) {
                        this.$root.$emit("disable-release-note-blink");
                    } else {
                        let message = response.data.response.message;
                        message = message.code + " : " + message.description;
                        this._message(message, "danger");
                        console.error(message);
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
};
</script>
<style>
div.whats-new {
    background: #ffffff;
    border: 1px solid #ddd;
    position: fixed;
    top: 0;
    right: -500px;
    width: 500px;
    max-width: 100vw;
    z-index: 1002;
    height: calc(100vh - 68px);
    transition: 0.5s;
}

div.whats-new.classic-layout {
    margin-top: 58px;
}
div.whats-new.enhanced-layout {
    margin-top: 52px;
}

.whats-new.show {
    transition: 0.5s;
    right: 0;
}

.whats-new .title {
    padding: 1.5em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #dbdbdb;
    background: #fff;
}

.whats-new .content-holder {
    overflow: scroll;
    height: calc(100% - 65px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.whats-new .content {
    padding: 1.5em;
    border-bottom: 1px solid #dbdbdb;
}

.whats-new .img-holder {
    background: #f7f7f7;
    margin-bottom: 1.2em;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ddd;
}

.whats-new .img-holder img {
    width: 100%;
}

.whats-new .load-more {
    text-align: center;
    padding: 1em;
    letter-spacing: 1px;
    cursor: pointer;
    background: #dbdbdb;
}

.no-release {
    color: #d6d5d5;
    text-align: center;
    margin: 2em 0;
}

.no-release i {
    font-size: 8em;
    margin-bottom: 10px;
}

.no-release .refresh {
    color: #000000;
    cursor: pointer;
    margin-top: 10px;
}

@media screen and (min-width: 992px) {
    div.whats-new.classic-layout {
        margin-top: 64px;
    }
}
</style>
